export const isDev = () => {
	const {hostname} = window.location;
	const master = [
		'ac.bhp.lifeon.cl'
	];
	//console.log({hostname})
	return !master.find(m => hostname.includes(m));
}
const dev = isDev();

export const AC = dev
	? 'https://ac.dev.bhp.lifeon.cl/api'
	: 'https://ac.bhp.lifeon.cl/api';

/** Frontend 2 (centralized login) base URL */
export const FRONTEND_V2 = (() => {
	const {hostname} = window.location;
	if (hostname === 'localhost' || hostname === '127.0.0.1') {
		return 'http://localhost:3001';
	}
	if (hostname.includes('ac.bhp.lifeon.cl') && !hostname.includes('dev') && !hostname.includes('release')) {
		return 'https://v2.ac.bhp.lifeon.cl';
	}
	return 'https://v2.ac.dev.bhp.lifeon.cl';
})();

export const PROCEDURE_PDF = 'https://pdf.procedimientos.dev.bhp.lifeon.cl/';

//export const ENDPOINT_ = `${AC}//`;
export const ENDPOINT_PUBLIC_FILE_1 = dev
	? 'https://public-files.ac.dev.bhp.lifeon.cl/public_file/1/'
	: 'https://public-files.ac.bhp.lifeon.cl/public_file/1/'

/* 	POST /service/mail/expired_issue_tracker/all/
	POST /service/mail/expired_issue_tracker/<issue_id>/
 */

export const ENDPOINT_SERVICE_MAIL_EXPIRED_ISSUE_TRACKER_ALL = `${AC}/service/mail/expired_issue_tracker/all/`;
export const ENDPOINT_SERVICE_MAIL_EXPIRED_ISSUE_TRACKER = `${AC}/service/mail/expired_issue_tracker/`;

export const ENDPOINT_CRITICAL_ASSETS_TO_CSV = `${AC}/critical_asset_to_csv/`;
export const ENDPOINT_SPARE_PART_TO_CSV = `${AC}/spare_part_to_csv/`;
export const ENDPOINT_DATA_ACTION_TRACKER_TYPES = `${AC}/data/action_tracker/types/`;
export const ENDPOINT_KRI = `${AC}/kris/`;
export const ENDPOINT_UPLOAD_KRI = `${AC}/upload/kri/`;
export const ENDPOINT_PRT_FILES_FILTER = `${AC}/prt_files_filter/`;
export const ENDPOINT_ACTIONS = `${AC}/actions/`;
export const ENDPOINT_CACHE_TO_CRITICAL_ASSET = `${AC}/cache_to_critical_asset/`;
export const ENDPOINT_CREATE_CRITICAL_ASSET_CACHE = `${AC}/create_critical_asset_cache/`;
export const ENDPOINT_ADD_FILES_CRITICAL_ASSET = `${AC}/add_files_critical_asset/`;
export const ENDPOINT_GENERIC_FILES = `${AC}/generic_files/`;
export const ENDPOINT_ROLES = `${AC}/roles/`;
export const ENDPOINT_ROLE = `${AC}/role/`;
export const ENDPOINT_EBITS = `${AC}/ebits/`;
export const ENDPOINT_EBIT = `${AC}/ebit/`;
export const ENDPOINT_IMPACTED_AREAS_EBITS = `${AC}/impacted_areas_ebits/`;
export const ENDPOINT_PERMISSIONS = `${AC}/permissions/`;
export const ENDPOINT_PERMISSION = `${AC}/permission/`;
export const ENDPOINT_PROFILES = `${AC}/profiles/`;
export const ENDPOINT_PROFILE = `${AC}/profile/`;
export const ENDPOINT_USER_ASSETS = `${AC}/user_assets/`;
export const ENDPOINT_FORWARD_WORKFLOW = `${AC}/forward_workflow/`;
export const ENDPOINT_TRACK_ACTIVITIES = `${AC}/track_activities/`;
export const ENDPOINT_WF_NULL = `${AC}/workflows/?approbation_date__isnull=true&status=1`;
export const ENDPOINT_WORKFLOWS = `${AC}/workflows/`;
export const ENDPOINT_WORKFLOW = `${AC}/workflow/`;
export const ENDPOINT_WORKFLOW_CRITICAL_ASSET = `${AC}/workflow_files/`;
//export const ENDPOINT_WORKFLOW_CRITICAL_ASSET = `${AC}/workflow_critical_asset/`;
export const ENDPOINT_TOKEN = `${AC}/api/token/`;
export const ENDPOINT_TOKEN_REFRESH = `${AC}/api/token/refresh/`;
export const ENDPOINT_TOKEN_REFRESH_USER = `${AC}/api/token/refresh/`;
export const ENDPOINT_SSO_CONSUME = `${AC}/api/sso/consume/`;
export const ENDPOINT_SSO_HANDOFF = `${AC}/api/sso/handoff/`;
export const ENDPOINT_AC_WITH_PRT_FILES = `${AC}/ac_with_prt_files/`;
export const ENDPOINT_STANDARDS = `${AC}/standards/`;
export const ENDPOINT_STANDARD = `${AC}/standard/`;
export const ENDPOINT_PRT_FILES = `${AC}/prt_files/`;
export const ENDPOINT_PRT_FILE = `${AC}/prt_file/`;

export const ENDPOINT_SPARE_PARTS = `${AC}/spare_parts/`;
export const ENDPOINT_SPARE_PART = `${AC}/spare_part/`;
export const ENDPOINT_USERS = `${AC}/users/`;
export const ENDPOINT_USER = `${AC}/user/`;
export const ENDPOINT_ACTION_TRACKER_ISSUES = `${AC}/action_tracker_issues/`;
export const ENDPOINT_UPLOAD_ACTION_TRACKER = `${AC}/upload/action_tracker/`;
export const ENDPOINT_UPLOAD_PWO_SHEET = `${AC}/upload/pwo_sheet/file/`;

export const ENDPOINT_CREATE_CRITICAL_ASSET = `${AC}/create_critical_asset/`;
export const ENDPOINT_CRITICAL_ASSETS = `${AC}/critical_assets/`;
export const ENDPOINT_CRITICAL_ASSET = `${AC}/critical_asset/`;
export const ENDPOINT_ORGANIZATIONS = `${AC}/organizations/`;
export const ENDPOINT_IMPACTED_AREAS = `${AC}/impacted_areas/`;
export const ENDPOINT_SPECIALITIES = `${AC}/specialities/`;

export const ENDPOINT_PWO_COMPLIANCES = `${AC}/pwo_compliances/`;
export const ENDPOINT_PWO_CANCELLEDS = `${AC}/pwo_cancelleds/`;
export const ENDPOINT_PWO_OVERDUES = `${AC}/pwo_overdues/`;
export const ENDPOINT_CRITICAL_ASSET_BY_ORGANIZATION = `${AC}/aggregate/critical_asset_by_organization/`;
export const ENDPOINT_CRITICAL_ASSET_DETAIL_FUNCTIONAL_LOCATION = `${AC}/join/critical_asset/detail/functional_location/`;
//export const ENDPOINT_CRITICAL_ASSET_DETAIL_FUNCTIONAL_LOCATION = `${AC}/join/critical_asset/detail/fl/`;
export const ENDPOINT_CRITICAL_ASSET_DETAIL_FL = `${AC}/join/critical_asset/detail/functional_location/`;

export const ENDPOINT_CRITICAL_ASSET_BY_STATUS_NUMBER = `${AC}/aggregate/critical_asset_by_status/number/`;
export const ENDPOINT_CRITICAL_ASSET_BY_STATUS_VALUE = `${AC}/aggregate/critical_asset_by_status/value/`;
export const ENDPOINT_UPLOAD_ACTIONS = `${AC}/upload/actions/`;

export const ENDPOINT_FUNCTION_DISCHARGE_PARTS = `${AC}/function/discharge_parts/`;
export const ENDPOINT_FUNCTION_CHECK_DISCHARGE_PARTS = `${AC}/function/check_discharge_parts/`;
export const ENDPOINT_HELPER_GET_CURRENT_FISCAL_YEAR = `${AC}/helper/get_current_fiscal_year/`;

export const ENDPOINT_DASHBOARD_METRICS_PERCENTAGE = `${AC}/dashboard/metrics/percentage/`;

export const ENDPOINT_DASHBOARD_ACTIONS_PRIORITY_ACTIONS = `${AC}/dashboard/actions/priority_actions/all/`;
export const ENDPOINT_DASHBOARD_ACTIONS_PRIORITY = `${AC}/dashboard/actions/priority/all/`;

export const ENDPOINT_EXPORT_METRICS = `${AC}/export/metrics/`;
export const ENDPOINT_EXPORT_EBITS = `${AC}/export/ebits/`;
export const ENDPOINT_EXPORT_ACTION_TRACKER_ISSUE = `${AC}/export/action_tracker_issue/`;
export const ENDPOINT_EXPORT_ACTIONS = `${AC}/export/actions/`;
export const ENDPOINT_EXPORT_KRI = `${AC}/export/kri/`;
export const ENDPOINT_EXPORT_CRITICAL_ASSET_PRT_FILES = `${AC}/export/critical_asset/prt_files/`;
export const ENDPOINT_EXPORT_CRITICAL_ASSET_REVISION = `${AC}/export/critical_asset/revision/`;
export const ENDPOINT_EXPORT_CRITICAL_ASSET_HISTORICAL = `${AC}/export/critical_asset/historical/`;
export const ENDPOINT_EXPORT_CRITICAL_ASSET_DISCHARGED = `${AC}/export/critical_asset/discharged/`;
export const ENDPOINT_EXPORT_SPARE_PART_REVISION = `${AC}/export/spare_part/revision/`;
export const ENDPOINT_EXPORT_SPARE_PART_HISTORICAL = `${AC}/export/spare_part/historical/`;
export const ENDPOINT_EXPORT_SPARE_PART_DISCHARGED = `${AC}/export/spare_part/discharged/`;
export const ENDPOINT_EXPORT_USERS = `${AC}/export/users/`;
export const ENDPOINT_EXPORT_TRACKING = `${AC}/export/tracking/`;
export const ENDPOINT_EXPORT_ASI_REQUESTS = `${AC}/export/asi_requests/`;
export const ENDPOINT_CRITICAL_ASSET_PRT_FILES = `${AC}/critical_asset_prt_files/`;
export const ENDPOINT_DASHBOARD_KRI_PIVOT_TABLE = `${AC}/dashboard/kri/pivot_table/`;
export const ENDPOINT_KRIS = `${AC}/kris/`;
export const ENDPOINT_DASHBOARD_KRI_REPORT_TABLE = `${AC}/dashboard/kri/report_table/`;
export const ENDPOINT_DASHBOARD_KRI_SUMMARY_TABLE = `${AC}/dashboard/kri/summary_table/`;
export const ENDPOINT_FISCAL_YEARS = `${AC}/fiscal_years/`;
export const ENDPOINT_CHANGE_FISCAL_YEAR = `${AC}/change_fiscal_year/`;
export const ENDPOINT_SHEET_UPDATE = `${AC}/sheet_update/`;
export const ENDPOINT_PAGINATED_ACTION_TRACKER_ISSUES = `${AC}/paginated/action_tracker_issues/`;
export const ENDPOINT_DASHBOARD_ACTION_TRACKER_ISSUE_BARPLOT = `${AC}/dashboard/action_tracker_issue/barplot/`;
export const ENDPOINT_DASHBOARD_ACTION_TRACKER_ISSUE_DONUT = `${AC}/dashboard/action_tracker_issue/donut/`;
export const ENDPOINT_DASHBOARD_METRICS_REPORT_TABLE = `${AC}/dashboard/metrics/report_table/`;


export const ENDPOINT_DASHBOARD_METRICS_SPECIFIC_HEADERS = `${AC}/dashboard/metrics/specific/headers/`;
export const ENDPOINT_DASHBOARD_METRICS_SPECIFIC = `${AC}/dashboard/metrics/specific/`;

export const ENDPOINT_CUSTOM_CREATE_USER = `${AC}/custom/create/user/`;
export const ENDPOINT_CUSTOM_UPDATE_USER = `${AC}/custom/update/user/`;

export const ENDPOINT_DASHBOARD_KRI_INDIVIDUAL_TABLE = `${AC}/dashboard/kri/individual_table/`;
export const ENDPOINT_EDIT_KRI_1_2 = `${AC}/edit/kri_1_2/`;
export const ENDPOINT_JOIN_CRITICAL_ASSET_DETAIL_FL = `${AC}/join/critical_asset/detail/fl/`;
export const ENDPOINT_CRITICAL_ASSET_FILE_TYPES = `${AC}/critical_asset_file_types/`;

export const ENDPOINT_SIMULATIONS_COMPUTED_VALUES_CRITICAL_ASSET = `${AC}/simulations/computed_values/critical_asset/`;
export const ENDPOINT_SIMULATIONS_COMPUTED_VALUES_SPARE_PART = `${AC}/simulations/computed_values/spare_part/`;

export const ENDPOINT_PREVENTIVE_WORK_ORDER_TIMES = `${AC}/preventive_work_order_times/`;//no recuerdon donde se usa

export const ENDPOINT_ASSET_CLASS_A_ALL = `${AC}/asset_class/a/all/`;

export const ENDPOINT_FUNCTION_MANUAL_DISCHARGE_CRITICAL_ASSET = `${AC}/function/manual_discharge/critical_asset/`;
export const ENDPOINT_FUNCTION_MANUAL_DISCHARGE_SPARE_PART = `${AC}/function/manual_discharge/spare_part/`;
export const ENDPOINT_DISCHARGE_PART_FILES = `${AC}/discharge_part_files/`;










export const ENDPOINT_GET_LIMIT = `${AC}/data/get_limit/`;
export const ENDPOINT_FUNCTION_DARK_MODE = `${AC}/function/dark_mode/`;



export const ENDPOINT_ACTION_PHOTOGRAPHIC_RECORDS = `${AC}/action_photographic_records/`;
export const ENDPOINT_ACTION_PHOTOGRAPHIC_RECORD = `${AC}/action_photographic_record/`;
export const ENDPOINT_CRITICAL_ASSET_IMAGES = `${AC}/critical_asset_images/`;
export const ENDPOINT_SPARE_PART_IMAGE = `${AC}/spare_part_image/`;
export const ENDPOINT_ACTION_DOCUMENTS = `${AC}/action_documents/`;
export const ENDPOINT_ACTION_DOCUMENT = `${AC}/action_document/`;
export const ENDPOINT_ACTION_WORKFLOWS = `${AC}/action_workflows/`;
export const ENDPOINT_REVIEW_ACTION = `${AC}/review_action/`;
export const ENDPOINT_REMEDIATION_ACTIONS = `${AC}/remediation_actions/`;

export const ENDPOINT_CLOSING_VALIDATION_ACTION = `${AC}/closing_validation_action/`;






export const ENDPOINT_SIMULATIONS_CRITICAL_ASSETS = `${AC}/simulations/critical_assets/`;
export const ENDPOINT_SIMULATIONS_SPARE_PARTS = `${AC}/simulations/spare_parts/`;

export const ENDPOINT_SIMULATIONS_CRITICAL_ASSET = `${AC}/simulations/critical_asset/`;
export const ENDPOINT_SIMULATIONS_SPARE_PART = `${AC}/simulations/spare_part/`;

export const ENDPOINT_SIMULATIONS_TO_ASI_REQUEST_CRITICAL_ASSET = `${AC}/simulations/to_asi_request/critical_asset/`;
export const ENDPOINT_SIMULATIONS_TO_ASI_REQUEST_SPARE_PART = `${AC}/simulations/to_asi_request/spare_part/`;

export const ENDPOINT_SIMULATIONS_JOIN_CA_WITH_SCAS = `${AC}/simulations/join_ca_with_scas/`;
export const ENDPOINT_IMPACT_PERCENTAGE_FILES = `${AC}/custom/impact_percentage_files/`;
export const ENDPOINT_IMPACT_PERCENTAGE_FILE = `${AC}/custom/impact_percentage_file/`;

